module.exports = __webpack_public_path__ + "static/media/vid.e8a0a8f2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assests/vid.mp4
// module id = 125
// module chunks = 0